import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  headersWithoutAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const inviteServices = {
  inviteUser,
  cancelInvitation,
  acceptRejectInvitation,
  resendInvitation,
  deleteInvitation,
  getInvitation,
  getApprovalInvitation,
  getSingleInvitationData,
  getInvitationByToken,
};

// Invite User
async function inviteUser(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}inviteUser`,
    headersWithAuth("POST", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Cancel Invite
async function cancelInvitation(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}cancelInvitation`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Resend Invitation
async function resendInvitation(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}resendInvitation`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Accept and Reject Invitation
async function acceptRejectInvitation(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}acceptRejectInvitation`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Invitation
async function deleteInvitation(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteInvitation`,
    headersWithAuth("DELETE", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Invitation
async function getInvitation(auth, status, searchData, page, length) {
  try {
    const signal = cancelPreviousRequest("getInvitation");
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getInvitation/${status}?search=${searchData || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getInvitation/${status}?search=${searchData || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Approval Invitation
async function getApprovalInvitation(auth, status, searchData, page, length) {
  try {
    const signal = cancelPreviousRequest("getApprovalInvitation");
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getApprovalInvitation/${status}?search=${searchData || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getApprovalInvitation/${status}?search=${searchData || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Invitation
async function getSingleInvitationData(auth, id) {
  try {
    const signal = cancelPreviousRequest("getSingleInvitationData");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleInvitationData/${id}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Inivitation Details By Token
async function getInvitationByToken(token) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getInvitationByToken/${token}`,
    headersWithoutAuthWithoutBody("GET")
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}
